import { render } from "./PurchaseHeader.vue?vue&type=template&id=7b27e5fc"
import script from "./PurchaseHeader.vue?vue&type=script&lang=js"
export * from "./PurchaseHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__